import { FunctionComponent } from "react";
import * as Styled from "./styles";

const FullPageLoader: FunctionComponent = () => {
  return (
    <Styled.FullScreenLoader className="loader-div" data-testid="loader">
      <span className="loader">
        <span />
        <span />
      </span>
    </Styled.FullScreenLoader>
  );
};

export default FullPageLoader;
